import { SettingRow } from '../../../../Manage/Operator/Settings/SettingRow';
import { Input } from '../../../../../components/Input';
import { Divider } from '../../../../../components/Divider';
import { useCreateOperator } from '../../../../../contexts/CreateOperatorContext';
import { ChangeEvent } from 'react';
import { CloudDvrs } from './CloudDvrs';
import { ExperienceGroups } from './ExperienceGroups';
import { RoutingGroups } from './RoutingGroups';
import { MoneyOff } from '@material-ui/icons';

export const MediaFirst = () => {
  const { operator, updateOperator } = useCreateOperator();
  const classes = useStyles();

  if (operator.mediaFirstSettings === undefined) return null;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    updateOperator(
      'mediaFirstSettings',
      Object.assign(operator.mediaFirstSettings!, {
        [event.target.name]: event.target.value,
      })
    );
  };

  const defaultInputProps: any = {
    variant: 'contained',
    onChange: handleChange,
  };

  return (
    <div className={classes.container}>
      <SettingRow
        level="sub"
        title="Free Channel Group"
        icon={<MoneyOff />}
        description="The channel group that is used for providing free content to accounts"
      >
        <Input name="freeChannelGroup" {...defaultInputProps} />
      </SettingRow>
      <Divider />
      <CloudDvrs />
      <Divider />
      <ExperienceGroups />
      <Divider />
      <RoutingGroups />
    </div>
  );
};

const useStyles = () => ({
  container: 'flex flex-col gap-2 items-center box-border',
  input: 'w-[80px]',
});
